import { sva } from "@agapi/ui/panda/css";
export const cardStyles = sva({
    slots: ["root", "image", "header", "content", "container", "footer"],
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            borderRadius: "surface.sm",
            overflow: "hidden",
            boxShadow: "sm",
            position: "relative",
        },
        image: {
            width: "100%",
            objectFit: "cover",
        },
        container: {
            position: "absolute",
        },
        header: {
            display: "flex",
            flexDir: "column",
            px: "var(--contentPadding)",
            pt: "var(--contentPadding)",
            gap: "2",
        },
        content: {
            py: "tight",
            px: "var(--contentPadding)",
            flex: 1,
            _last: {
                pb: "var(--contentPadding)",
            },
            _first: {
                pt: "var(--contentPadding)",
            }
        },
        footer: {
            display: "flex",
            flexDir: "column",
            px: "var(--contentPadding)",
            pb: "var(--contentPadding)",
        }
    },
    variants: {
        imageBg: {
            true: {
                root: {
                    _before: {
                        content: '""',
                        float: "left",
                        pb: "70%",
                    },
                    _after: {
                        display: 'table',
                        content: "''",
                        clear: "both",
                    }
                },
                image: {
                    position: 'absolute',
                    height: "100%",
                    top: '0',
                    left: '0',
                    bottom: '0',
                    right: '0',
                    zIndex: '0',
                }
            },
            false: {
                image: {
                    aspectRatio: "16/9",
                }
            }
        }
    }
});
